import { z } from 'zod';

/**
 * Shared constants and payload of the `client-reply` e-mail job: the debounced
 * notice that tells a client about staff replies in their comment thread. The
 * API (scheduler) and the worker (processor, sweep) cannot import each other.
 * The deterministic job id (`clientReplyJobId`) lives in `@cp/core/email`
 * because it needs Node crypto, which `apps/web` (also a consumer of this
 * package) must not pull in.
 */
export const CLIENT_REPLY_JOB = 'client-reply';

/** Quiet period before the notice goes out; later replies extend the batch. */
export const CLIENT_REPLY_DEBOUNCE_MS = 15 * 60 * 1000;

export const ClientReplyJobSchema = z.object({
  organizationId: z.string().guid(),
  hotelId: z.string().guid(),
  recipient: z.string().trim().toLowerCase().email(),
});
export type ClientReplyJob = z.infer<typeof ClientReplyJobSchema>;
